// extracted by mini-css-extract-plugin
module.exports = {"container":"e_sB","sizeSmall":"e_tB","on":"e_uB","handle":"e_vB","variantGrey":"e_wB","variantPrimary":"e_xB"};